import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Table, Button, Tag } from 'antd';
import { BulbFilled } from '@ant-design/icons';
import Loader from '../util/Loader';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import StarsSharpIcon from '@material-ui/icons/StarsSharp';
import PopupComponent from "../util/RewardPopup";
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import SelectCenter from "../util/SelectCenter";
import Filter from '../util/Filter';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import setup from '../setup';

let clear = false;
let name = '';
let phone = '';

let filterMode = {
    name : true,
    phone : true
}

let storage = {
    nameKeyword : '',
    phoneKeyword : '',
    popupMode : '',
    popupData : {}
}

function Reward() {
    const [showPopup, setShowPopup] = useState(false);
    const [selectedCenter, setSelectedCenter ] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();
    
    const columns = [
        {
            title : '센터명',
            dataIndex : 'cname',
            key : 'cname'
        },
        {
            title : '이름',
            dataIndex : 'name',
            key : 'name'
        },
        {
            title : '연락처',
            dataIndex : 'phone',
            key : 'phone'
        },
        {
            title : '레벨',
            dataIndex : 'level',
            key : 'level',
            sorter: (a, b) => a.level_code - b.level_code
        },
        {
            title : '수령여부',
            dataIndex : 'takeout_yn',
            key : 'takeout_yn',
            render : takeout_yn => {
                return (
                    takeout_yn === 'Y' ? <Tag color="blue">수령</Tag> : <Tag>미수령</Tag>
                )
            }
        },
        {
            title : '수령일',
            dataIndex : 'take_date',
            key : 'take_date',
            render : take_date => {
                return(
                    take_date === '0000-00-00' || take_date === '1899-11-30' ? null : moment(take_date).format('YYYY-MM-DD')
                ) 
            }
        },
        {
            title : '등록일',
            dataIndex : 'regdate',
            key : 'regdate',
            render : regdate => {
                return moment(regdate).format('YYYY-MM-DD HH:mm')
            }
        }
    ]

    const onClickRow = (record) => {
        return {
            onClick : () => {
                openPopup("edit", record)
            }
        }
    }
    
    function openPopup(mode, data) {
        setShowPopup(true);
        storage.popupMode = mode;
        storage.popupData = data;
    }

    function closePopup(isUpdated) {
        setShowPopup(false);
        if(isUpdated === "updated"){
            getDataSource()
        }
    }

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
    }

    function handleClear(){
        storage.nameKeyword = '';
        storage.phoneKeyword = '';
        clear = true;
        getDataSource();
    }

    function handleFilter(filterData){
        storage.nameKeyword = filterData.nameKeyword;
        storage.phoneKeyword = filterData.phoneKeyword
        getDataSource();
    }
    
    function getDataSource(){
        if(clear === true){
            name = ''
            phone = '';
        }else{
            name = storage.nameKeyword;
            phone = storage.phoneKeyword;
        }
        let temp_cid = '';
        if(data.cid !== 'root'){
            temp_cid = data.cid
        }else{
            temp_cid = selectedCenter
        }

        (async function () {
            const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
            const result = await axios.post(api_host + '/hg_admin/get_reward', {
                cid: temp_cid,
                nameKeyword : name,
                phoneKeyword : phone
            })
            console.log(result.data.rows);
            setDataSource(result.data.rows);
        })();
    }

    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            const decodeResult = await DecodeData(data.url);
            dispatch({type:'SET', name:"CID", value:decodeResult.cid});
            dispatch({type:'SET', name:"LEVEL", value:decodeResult.level});
            getDataSource();
            setInterval(()=>{setIsLoading(false)}, 300); 
        }else{
            LoginFail();
        }
    }

    useEffect(()=>{
        main();
    },[]);

    useEffect(()=>{
        if(data.cid === "root"){
            getDataSource();
        }
    },[selectedCenter]);

    if (isLoading) return (
        <main className="main-container">
        <TopNav />
        <div className="content-wrapper">
        <MainNav />
        <Loader />
        </div>
        </main>
    )

    return (
        <main className="main-container">
            <TopNav />
            <div className="content-wrapper">
            <MainNav />
            <div className="content-inner">
            <h3 style={{display : "inline-block"}}>티셔츠 수령 관리</h3>
            <div className="content-component">
                <div className="content-header">
                <div>* 티셔츠 수령 가능 레벨 : 골드, 다이아몬드, 그랜드 마스터, 레전드</div>
                <SelectCenter 
                    onSelectedCenter={handleSelectedCenter}
                />
                </div>
                <div className="content-body">
                    <div className="table-header">
                        <div></div>
                        <div style={{display : "inline-flex"}}>
                        <Filter 
                            handleFilter = {handleFilter} 
                            handleClear = {handleClear}
                            mode = {filterMode}
                        />
                        </div>
                    </div>
                    <div className="table-body cursor">
                    <Table dataSource={dataSource} columns={columns} onRow={onClickRow} rowKey="seq" />
                    </div>
                </div>
            </div>
            {showPopup ? 
            <PopupComponent
                data = {storage.popupData}
                mode = {storage.popupMode}
                closePopup={closePopup}
            />
            : null
            }
            </div>
            </div>
        </main>
    )
}

export default Reward;